// extracted by mini-css-extract-plugin
export var orderSummary = "_qi-0";
export var showMoreLessButton = "_qi-1";